import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Nav, NavItem } from 'react-bootstrap';
import _ from 'lodash';

// Import style.
import './assets/style.css';

// Import layout
import SlidingContainer from '../../utils/layout/SlidingContainer';

// Import Admin Tabs.
import { tabs } from '../../config';

class AdminPage extends Component {
  handleTabSelect(activeTab, event) {
    const selectedTab =
      (event && event.target && event.target.id) || tabs.adminTabs[activeTab];
    if (selectedTab)
      this.context.router.push(`/admin/${selectedTab.toLowerCase()}`);
  }

  buildAdminTables() {
    const { active, currentUser } = this.props;
    const { adminTabs } = tabs;

    if (!_.includes(currentUser.roles, 'LogisticsAssociate'))
      return (
        <Nav
          bsStyle="pills"
          activeKey={active.key}
          onSelect={this.handleTabSelect.bind(this)}
        >
          {adminTabs.map((adminTab, index) => {
            return (
              <NavItem
                key={index}
                eventKey={index}
                id={adminTab.toLowerCase()}
                aria-label={`admin ${adminTab}`}
              >
                {adminTab.replace(/([a-z])([A-Z])/g, '$1 $2')}
              </NavItem>
            );
          })}
        </Nav>
      );
    else if (_.includes(currentUser.roles, 'LogisticsAssociate'))
      return (
        <Nav
          bsStyle="pills"
          activeKey={0}
          onSelect={this.handleTabSelect.bind(this)}
        >
          <NavItem key={0} eventKey={0} id={'users'} active>
            {'Users'}
          </NavItem>
        </Nav>
      );
  }

  render() {
    const { active } = this.props;

    return (
      <SlidingContainer title={`${active.pageTitle} - Administration`}>
        <div className="admin-page">
          {this.buildAdminTables()}
          {/* Render child routes */}

          <div className="admin-child-page">{this.props.children}</div>
        </div>
      </SlidingContainer>
    );
  }
}

AdminPage.propTypes = {
  active: PropTypes.object.isRequired,
};

AdminPage.contextTypes = {
  router: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    active: state.admin.active,
    currentUser: state.auth.user,
  };
}

export default connect(mapStateToProps, {})(AdminPage);
